/**
 * Auth helpers. Single source of truth for the token key + presence check.
 * Updating storage strategy (cookies, encrypted store, etc.) becomes a one-file change here.
 *
 * The token itself is attached to every axios request by the global interceptor in App.js —
 * pages should NOT manually set Authorization headers.
 */
const TOKEN_KEY = "landclearco_token";

export const getAuthToken = () => {
  if (typeof window === "undefined") return null;
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
};

export const isAdminLoggedIn = () => !!getAuthToken();
